import React from 'react';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import Field from 'redux-form/es/Field';
import InputField from 'components/Credit24/Core/Controls/InputField';
import InputDatePicker from 'components/Credit24/Core/Controls/InputDatePicker';
import InputToggleGroup from 'components/Credit24/Core/Controls/InputToggleGroup';
import InputToggleField from 'components/Credit24/Core/Controls/InputToggleField';
import { useTranslationSuffix } from 'hooks/useTranslationSuffix';

const propTypes = {
  minDate: PropTypes.object.isRequired,
  maxDate: PropTypes.object.isRequired,
  incomeFrequencies: PropTypes.array.isRequired,
  calendarEnabled: PropTypes.bool,
  hasGovernmentBenefits: PropTypes.bool,
  incomeLimitValues: PropTypes.object,
};

const IncomeAU = (props) => {
  const {
    minDate, maxDate, incomeFrequencies, calendarEnabled, hasGovernmentBenefits, incomeLimitValues,
  } = props;

  const translationKeys = {
    incomeTitle: 'income.title',
    incomeSubtitle: 'income.subtitle',
    incomeAmountDesc: 'income_amount.desc',
    incomeGovBenefitsTitle: 'income_government_benefits.title',
    incomeGovBenefitsHint: 'income_government_benefits.hint',
    incomePayDayDesc: 'income_pay_day.desc',
  };
  const translations = useTranslationSuffix('upgrade', translationKeys);

  return (
    <div className="loan-form__step">
      <h1 className="loan-form__step-title">
        <FormattedMessage id={translations.incomeTitle} />
      </h1>
      <div className="loan-form__step-body">
        <h3 className="loan-form__step-subtitle">
          <FormattedHTMLMessage id={translations.incomeSubtitle} />
        </h3>
        <div className="grid">
          <div className="grid__item one-half palm-one-whole">
            <Field
              title={<FormattedMessage id="income_amount.title" />}
              name="incomeAmount"
              component={InputField}
              prefix="$"
              useDigitsGrouping
              isFullWidth
              errorValues={incomeLimitValues}
            />
            <p className="hint">
              <FormattedHTMLMessage id={translations.incomeAmountDesc} />
            </p>
          </div>
          <div className="grid__item one-half palm-one-whole">
            <InputToggleGroup
              name="incomeFrequency"
              list={incomeFrequencies}
            />
          </div>
          <div className="grid__item palm-one-whole">
            <Field
              title={<FormattedHTMLMessage id={translations.incomeGovBenefitsTitle} />}
              subtitle={<FormattedMessage id={translations.incomeGovBenefitsHint} />}
              name="governmentBenefits"
              component={InputToggleField}
            />
            { hasGovernmentBenefits && (
            <div className="grid">
              <div className="grid__item one-half palm-one-whole">
                <Field
                  title={<FormattedMessage id="income_government_benefits_amount.title" />}
                  name="governmentBenefitsAmount"
                  component={InputField}
                  prefix="$"
                  useDigitsGrouping
                  isFullWidth
                />
              </div>
              <div className="grid__item one-half palm-one-whole">
                <InputToggleGroup
                  name="governmentBenefitsFrequency"
                  list={incomeFrequencies}
                />
              </div>
            </div>
            )}
          </div>
          <div className="grid__item one-half palm-one-whole">
            <Field
              title={<FormattedMessage id="income_pay_day.title" />}
              type="text"
              name="incomePayDayDate"
              component={InputDatePicker}
              range={{ minDate, maxDate }}
              isFullWidth
              disabled={!calendarEnabled}
            />
            <p className="hint">
              <FormattedMessage id={translations.incomePayDayDesc} />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

IncomeAU.propTypes = propTypes;

export default IncomeAU;
